import { isEqual } from 'lodash-es';
import { IRequestOptions, IRequestData, viewRequest } from './dashboardRequest';

interface IRequestModel {
  method: string;
  data: IRequestData;
  session: Promise<any>;
  time: number;
}

interface IRequestMap {
  [url: string]: IRequestModel;
}

const requestMap: IRequestMap = {};

const expirationTime = 3 * 1000; // 有效期 3s

/**
 * 处理model类请求数据，主要用来避免同个接口的多次请求，
 * @param options.url：请求地址，string类型
 * @param options.data.gameCode：游戏code
 * @param options.data.filters：筛选器数据
 * @param options.data 传递的所有参数
 * @returns
 */
export default (opinions: IRequestOptions) => {
  const { url, method, data } = opinions;
  if (requestMap?.[url]) {
    const { method: oldMethod, data: oldData, time, session } = requestMap?.[url] || {};
    const now = Date.now();
    // 检测缓存是否命中
    if (method === oldMethod && (now - time <  expirationTime) && isEqual(data, oldData)) {
      return session;
    }
  }
  
  // 调用底层http请求
  const session = viewRequest(opinions);
  // 缓存当前请求，后续相同请求直接返回缓存结果
  requestMap[url] = {
    method,
    data,
    session,
    time: Date.now()
  };
  return session;
}

